import { noJSHandler } from "@modules/nojs";
import { initAccordionGroup, initMobileAccordions } from "./modules/accordion";
import { initMainNav } from "./modules/main-nav";
import LinkCardHandler from "./modules/link-card";
import { handlePrintEvents } from "./modules/print";
document.addEventListener('DOMContentLoaded', function () {
    // These should be run as soon as possible as they remove classes and attributes added to satisy print / no js requirements.
    noJSHandler();
    handlePrintEvents();
    initMainNav();
    // Link Cards
    var linkCards = Array.from(document.querySelectorAll(".js-link-card"));
    var linkCardsHandlers = [];
    if (linkCards.length > 0) {
        linkCards.forEach(function (linkCard) {
            var primaryHrefElement = linkCard.querySelector('.js-link-card-primary-href');
            linkCardsHandlers.push(new LinkCardHandler({
                wrapper: linkCard,
                primaryHrefElement: primaryHrefElement
            }));
        });
    }
    // mobile only accordions
    var mobileAccordions = document.querySelectorAll('.js-mobile-accordion');
    if (mobileAccordions.length > 0) {
        initMobileAccordions(mobileAccordions);
    }
    // accordion group
    var accordionGroups = document.querySelectorAll('.js-accordion-group');
    if (accordionGroups.length > 0) {
        accordionGroups.forEach(function (accordionGroup) {
            initAccordionGroup(accordionGroup);
        });
    }
});
